import { TimingTowerData } from '../types/widget';

/**
 * Day 10 Demo Data - Production State as of Day 10
 * 
 * Represents production at the END of Day 10:
 * - Days 1-10: Completed with actual shot data
 * - Days 11-13: Planned but NOT yet shot (0 pages shot)
 * - This shows the production mid-way through with 3 days remaining
 * 
 * Totals (as of Day 10):
 * - Pages Shot: 43 (sum of Days 1-10)
 * - Scenes Shot: 52 (sum of Days 1-10)
 */
export const demoDay10TimingTowerData: TimingTowerData = {
  currentScriptVersion: 'Strip Schedule',
  scriptColor: 'GOLDENROD',
  scriptColorHex: '#DAA520',
  totalProductionDays: 13,
  totalScriptPages: 67.5,
  cumulativePagesShot: 43, // Sum of Days 1-10 only
  totalScriptScenes: 82,
  cumulativeScenesShot: 52, // Sum of Days 1-10 only
  currentDayNumber: 11, // Day 10 demo - current day is Day 11
  days: [
    // Day 1 - Completed
    {
      dayNumber: 1,
      status: 'completed',
      statusColor: '#48BB78',
      scenes: ['4', '51', '52', '58', '60pt'],
      scenesPlanned: ['4', '51', '52', '58', '60pt'],
      scenesShot: ['4', '51', '52', '58', '60pt'],
      plannedScenesCount: 5,
      shotScenesCount: 5,
      plannedPages: '4 2/8',
      actualPages: '3 7/8',
      plannedPagesNumeric: 4.25,
      actualPagesNumeric: 3.875,
      progressPercent: 91,
      crewCallTime: '07:00',
      actualFirstShotTime: '08:30',
      characters: [
        { characterId: '1', characterName: 'LAURA KALE', actorName: 'Cote de Pablo', callTime: null, actualTime: '07:00', arrivalVarianceMinutes: null },
        { characterId: '7', characterName: 'ETHAN KALE', actorName: 'JR Bourne', callTime: null, actualTime: '07:00', arrivalVarianceMinutes: null },
        { characterId: '8', characterName: 'KATHERINE (7yrs old)', actorName: 'Stella Edwards (K)', callTime: null, actualTime: '07:00', arrivalVarianceMinutes: null },
      ],
      punctualitySummary: { onTimeCount: 0, lateCount: 0, avgVarianceMinutes: null },
      firstLocation: { name: "LAURA'S HOUSE", status: 'EXT' },
      weather: { forecast: 'Mostly Sunny, 20% chance of rain', temp: 'High 66F / Low 39F' },
      lastUpdatedBy: { documentType: 'production_report', label: 'Production Report', reportedOn: '2016-03-29T00:00:00.000Z', updatedAt: '2025-11-26T17:12:36.580Z', referenceId: 'DPR-1' },
    },
    // Day 2 - Completed
    {
      dayNumber: 2,
      status: 'completed',
      statusColor: '#48BB78',
      scenes: ['14', '32A', '5A', '7A', '7B'],
      scenesPlanned: ['14', '32A', '5A', '7A', '7B'],
      scenesShot: ['5A', '7A', '7B', '7', '14', '32A'],
      plannedScenesCount: 5,
      shotScenesCount: 6,
      plannedPages: '4 5/8',
      actualPages: '4 4/8',
      plannedPagesNumeric: 4.625,
      actualPagesNumeric: 4.5,
      progressPercent: 97,
      crewCallTime: '07:00',
      actualFirstShotTime: '08:30',
      characters: [
        { characterId: '1', characterName: 'LAURA KALE', actorName: 'Cote de Pablo', callTime: '09:00', actualTime: '07:30', arrivalVarianceMinutes: -90 },
        { characterId: '3', characterName: 'DONNA NEURING', actorName: 'Annabelle Dexter-Jones', callTime: '16:00', actualTime: '12:00', arrivalVarianceMinutes: -240 },
        { characterId: '4', characterName: 'FORDE', actorName: 'Toby Hemingway', callTime: '16:00', actualTime: '13:30', arrivalVarianceMinutes: -150 },
      ],
      punctualitySummary: { onTimeCount: 3, lateCount: 0, avgVarianceMinutes: -160 },
      firstLocation: { name: 'PUMP STATION AERATION BASIN', status: 'EXT' },
      weather: { forecast: 'AM Clouds/PM Sun, 10% chance of rain', temp: 'High 66 / Low 39' },
      lastUpdatedBy: { documentType: 'production_report', label: 'Production Report', reportedOn: '2016-03-30T00:00:00.000Z', updatedAt: '2025-11-26T17:30:20.406Z', referenceId: 'DPR-2' },
    },
    // Day 3 - Completed
    {
      dayNumber: 3,
      status: 'completed',
      statusColor: '#48BB78',
      scenes: ['13', '16', '16A', '16PT', '55', '59', '60pt'],
      scenesPlanned: ['13', '16', '16A', '16PT', '55', '59', '60pt'],
      scenesShot: ['13', '14', '16', '16A', '55', '59', '60'],
      plannedScenesCount: 7,
      shotScenesCount: 7,
      plannedPages: '4 4/8',
      actualPages: '3 1/8',
      plannedPagesNumeric: 4.5,
      actualPagesNumeric: 3.125,
      progressPercent: 69,
      crewCallTime: '07:30',
      actualFirstShotTime: '08:30',
      characters: [
        { characterId: '3', characterName: 'DONNA NEURING', actorName: 'Annabelle Dexter-Jones', callTime: '08:30', actualTime: '08:30', arrivalVarianceMinutes: 0 },
        { characterId: '4', characterName: 'FORDE', actorName: 'Toby Hemingway', callTime: '08:30', actualTime: '08:30', arrivalVarianceMinutes: 0 },
      ],
      punctualitySummary: { onTimeCount: 2, lateCount: 0, avgVarianceMinutes: 0 },
      firstLocation: { name: "DONNA'S HOUSE - UTILITY CLOSET", status: 'INT' },
      weather: { forecast: 'Sunny, 0% chance of rain', temp: 'High 64F / Low 53F' },
      lastUpdatedBy: { documentType: 'production_report', label: 'Production Report', reportedOn: '2016-03-31T00:00:00.000Z', updatedAt: '2025-11-26T17:14:53.589Z', referenceId: 'DPR-3' },
    },
    // Day 4 - Completed
    {
      dayNumber: 4,
      status: 'completed',
      statusColor: '#48BB78',
      scenes: ['26', '56', '57', '60pt', '60VFX', '7'],
      scenesPlanned: ['26', '56', '57', '60pt', '60VFX', '7'],
      scenesShot: ['7', '26', '56', '57', '60'],
      plannedScenesCount: 6,
      shotScenesCount: 5,
      plannedPages: '5',
      actualPages: '3 1/8',
      plannedPagesNumeric: 5,
      actualPagesNumeric: 3.125,
      progressPercent: 63,
      crewCallTime: '08:00',
      actualFirstShotTime: '09:00',
      characters: [
        { characterId: '2', characterName: 'EDDY CONWAY', actorName: 'Jack Davenport', callTime: '09:00', actualTime: '09:00', arrivalVarianceMinutes: 0 },
        { characterId: null, characterName: 'JENNIFER', actorName: 'Cynthy Wu', callTime: '09:00', actualTime: '11:00', arrivalVarianceMinutes: 120 },
        { characterId: null, characterName: 'JOE ONGANYAN', actorName: 'Victor Onuigbo', callTime: '11:00', actualTime: '11:00', arrivalVarianceMinutes: 0 },
      ],
      punctualitySummary: { onTimeCount: 2, lateCount: 1, avgVarianceMinutes: 40 },
      firstLocation: { name: "CORRIDOR O/SIDE EDDY'S APARTMENT", status: 'INT' },
      weather: { forecast: 'High 73F / Low 53F, 0% chance of rain', temp: 'Sunny' },
      lastUpdatedBy: { documentType: 'production_report', label: 'Production Report', reportedOn: '2016-04-01T00:00:00.000Z', updatedAt: '2025-11-26T17:15:57.607Z', referenceId: 'DPR-4' },
    },
    // Day 5 - Completed
    {
      dayNumber: 5,
      status: 'completed',
      statusColor: '#48BB78',
      scenes: ['10', '11', '17', '31pt', '43', '44'],
      scenesPlanned: ['10', '11', '17', '31pt', '43', '44'],
      scenesShot: ['10', '11', '17', '43', '44', '31'],
      plannedScenesCount: 6,
      shotScenesCount: 6,
      plannedPages: '3 7/8',
      actualPages: '3 4/8',
      plannedPagesNumeric: 3.875,
      actualPagesNumeric: 3.5,
      progressPercent: 90,
      crewCallTime: '09:00',
      actualFirstShotTime: '10:00',
      characters: [],
      punctualitySummary: { onTimeCount: 0, lateCount: 0, avgVarianceMinutes: null },
      firstLocation: { name: 'PARKING LOT - COLLEGE CAMPUS', status: 'EXT' },
      weather: { forecast: 'High 81F / Low 53F, 0% chance of rain', temp: 'Sunny' },
      lastUpdatedBy: { documentType: 'production_report', label: 'Production Report', reportedOn: '2016-04-13T00:00:00.000Z', updatedAt: '2025-11-26T17:17:02.327Z', referenceId: 'DPR-5' },
    },
    // Day 6 - Completed
    {
      dayNumber: 6,
      status: 'completed',
      statusColor: '#48BB78',
      scenes: ['27', '28', '30', '40', '42'],
      scenesPlanned: ['27', '28', '30', '40', '42'],
      scenesShot: ['27', '28', '42', '40', '29'],
      plannedScenesCount: 5,
      shotScenesCount: 5,
      plannedPages: '3 6/8',
      actualPages: '2 2/8',
      plannedPagesNumeric: 3.75,
      actualPagesNumeric: 2.25,
      progressPercent: 60,
      crewCallTime: '11:00',
      actualFirstShotTime: '11:30',
      characters: [
        { characterId: '1', characterName: 'Laura Kale', actorName: 'Cote de Pablo', callTime: '10:00', actualTime: '10:30', arrivalVarianceMinutes: 30 },
        { characterId: '2', characterName: 'Donna Neuring', actorName: 'Annabelle Dexter-Jones', callTime: '10:00', actualTime: '10:30', arrivalVarianceMinutes: 30 },
      ],
      punctualitySummary: { onTimeCount: 1, lateCount: 4, avgVarianceMinutes: 87 },
      firstLocation: { name: 'WALKWAY AT MOTEL', status: 'EXT' },
      weather: { forecast: 'High 86F / Low 60F, 0% chance of rain', temp: 'Sunny' },
      lastUpdatedBy: { documentType: 'production_report', label: 'Production Report', reportedOn: '2016-04-05T00:00:00.000Z', updatedAt: '2025-11-26T17:17:59.503Z', referenceId: 'DPR-6' },
    },
    // Day 7 - Completed
    {
      dayNumber: 7,
      status: 'completed',
      statusColor: '#48BB78',
      scenes: ['25', '26pt', '26VFX', '30', '40pt', '41'],
      scenesPlanned: ['25', '26pt', '26VFX', '30', '40pt', '41'],
      scenesShot: ['25', '30', '40', '41'],
      plannedScenesCount: 6,
      shotScenesCount: 4,
      plannedPages: '6 5/8',
      actualPages: '6 3/8',
      plannedPagesNumeric: 6.625,
      actualPagesNumeric: 6.375,
      progressPercent: 96,
      crewCallTime: '11:00',
      actualFirstShotTime: '11:30',
      characters: [
        { characterId: '1', characterName: 'Laura KALE', actorName: 'Cote de Pablo', callTime: '10:00', actualTime: '12:00', arrivalVarianceMinutes: 120 },
        { characterId: '2', characterName: 'Donna NEURING', actorName: 'Annabelle Dexter-Jones', callTime: '10:00', actualTime: '12:00', arrivalVarianceMinutes: 120 },
      ],
      punctualitySummary: { onTimeCount: 3, lateCount: 2, avgVarianceMinutes: -90 },
      firstLocation: { name: 'DINER', status: 'INT' },
      weather: { forecast: 'Sunny, 0% chance of rain', temp: 'High 86 / Low 60' },
      lastUpdatedBy: { documentType: 'production_report', label: 'Production Report', reportedOn: '2016-04-06T00:00:00.000Z', updatedAt: '2025-11-26T17:19:02.613Z', referenceId: 'DPR-7' },
    },
    // Day 8 - Completed
    {
      dayNumber: 8,
      status: 'completed',
      statusColor: '#48BB78',
      scenes: ['19', '20', '23', '24A', '42A', 'VFX1'],
      scenesPlanned: ['19', '20', '23', '24A', '42A', 'VFX1'],
      scenesShot: ['19', '23'],
      plannedScenesCount: 6,
      shotScenesCount: 2,
      plannedPages: '5 3/8',
      actualPages: '3 5/8',
      plannedPagesNumeric: 5.375,
      actualPagesNumeric: 3.625,
      progressPercent: 67,
      crewCallTime: '12:00',
      actualFirstShotTime: '13:00',
      characters: [
        { characterId: '1', characterName: 'LAURA KALE', actorName: 'Cote de Pablo', callTime: '13:00', actualTime: '12:45', arrivalVarianceMinutes: -15 },
        { characterId: '2', characterName: 'EDDY CONWAY', actorName: 'Jack Davenport', callTime: '13:00', actualTime: '12:45', arrivalVarianceMinutes: -15 },
      ],
      punctualitySummary: { onTimeCount: 2, lateCount: 0, avgVarianceMinutes: -15 },
      firstLocation: { name: 'STORAGE FACILITY - SECTION D', status: 'EXT' },
      weather: { forecast: 'High 70 / Low 57 Cloudy 20% chance of rain', temp: 'High 70 / Low 57 Cloudy 20% chance of rain' },
      lastUpdatedBy: { documentType: 'production_report', label: 'Production Report', reportedOn: '2016-04-07T00:00:00.000Z', updatedAt: '2025-11-26T17:20:05.243Z', referenceId: 'DPR-8' },
    },
    // Day 9 - Completed
    {
      dayNumber: 9,
      status: 'completed',
      statusColor: '#48BB78',
      scenes: ['20', '21', '24A', '32', '42A', '45', '47', '47A', '48', '48pt', '49', '54', 'VFX3'],
      scenesPlanned: ['20', '21', '24A', '32', '42A', '45', '47', '47A', '48', '48pt', '49', '54', 'VFX3'],
      scenesShot: ['21', '47', '48', '49', '54', '47A'],
      plannedScenesCount: 13,
      shotScenesCount: 6,
      plannedPages: '5 4/8',
      actualPages: '4 7/8',
      plannedPagesNumeric: 5.5,
      actualPagesNumeric: 4.875,
      progressPercent: 89,
      crewCallTime: '12:30',
      actualFirstShotTime: '13:30',
      characters: [
        { characterId: '1', characterName: 'LAURA KALE', actorName: 'Cote de Pablo', callTime: '12:30', actualTime: '13:30', arrivalVarianceMinutes: 60 },
        { characterId: '2', characterName: 'EDDY CONWAY', actorName: 'Jack Davenport', callTime: '12:30', actualTime: '13:30', arrivalVarianceMinutes: 60 },
      ],
      punctualitySummary: { onTimeCount: 2, lateCount: 2, avgVarianceMinutes: 15 },
      firstLocation: { name: 'Storage Unit, 2415 Firestone Blvd. South Gate, CA 90280', status: 'INT' },
      weather: { forecast: '40% chance of rain, AM Showers. PREPARE FOR RAIN!', temp: 'High 66F / Low 58F' },
      lastUpdatedBy: { documentType: 'production_report', label: 'Production Report', reportedOn: '2016-04-08T00:00:00.000Z', updatedAt: '2025-11-26T17:21:15.060Z', referenceId: 'DPR-9' },
    },
    // Day 10 - Completed
    {
      dayNumber: 10,
      status: 'completed',
      statusColor: '#48BB78',
      scenes: ['33', '34', '38', '39', 'VFX2', 'VFX3'],
      scenesPlanned: ['33', '34', '38', '39', 'VFX2', 'VFX3'],
      scenesShot: ['33', '34', '38', '39', 'VFX2', 'VFX3'],
      plannedScenesCount: 6,
      shotScenesCount: 6,
      plannedPages: '7 7/8',
      actualPages: '7 6/8',
      plannedPagesNumeric: 7.875,
      actualPagesNumeric: 7.75,
      progressPercent: 98,
      crewCallTime: '11:00',
      actualFirstShotTime: '12:00',
      characters: [
        { characterId: '1', characterName: 'Laura Kale', actorName: 'Cote de Pablo', callTime: '12:00', actualTime: '12:00', arrivalVarianceMinutes: 0 },
        { characterId: '2', characterName: 'Eddy Conway', actorName: 'Jack Davenport', callTime: '12:00', actualTime: '12:00', arrivalVarianceMinutes: 0 },
      ],
      punctualitySummary: { onTimeCount: 5, lateCount: 0, avgVarianceMinutes: -39 },
      firstLocation: { name: 'PEDESTRIAN BRIDGE', status: 'EXT' },
      weather: { forecast: 'AM Clouds / PM Sun, 10% chance of rain', temp: 'High 68 / Low 55' },
      lastUpdatedBy: { documentType: 'production_report', label: 'Production Report', reportedOn: '2016-04-11T00:00:00.000Z', updatedAt: '2025-11-26T17:22:19.798Z', referenceId: 'DPR-10' },
    },
    // Day 11 - PLANNED (not yet shot)
    {
      dayNumber: 11,
      status: 'planned',
      statusColor: '#A0AEC0',
      scenes: ['20', '24A', '24B', '32', '42A', '45', '47Apt'],
      scenesPlanned: ['20', '24A', '24B', '32', '42A', '45', '47Apt'],
      scenesShot: [], // Not shot yet
      plannedScenesCount: 7,
      shotScenesCount: 0,
      plannedPages: '5 6/8',
      actualPages: '0/8',
      plannedPagesNumeric: 5.75,
      actualPagesNumeric: 0,
      progressPercent: 0,
      crewCallTime: '13:00',
      actualFirstShotTime: 'N/A',
      characters: [],
      punctualitySummary: { onTimeCount: 0, lateCount: 0, avgVarianceMinutes: null },
      firstLocation: { name: "DONNA'S PICK-UP - STORAGE PARKING LOT", status: 'INT' },
      weather: { forecast: 'High: 68F, Low: 56F, 0% chance of rain', temp: 'Partly Cloudy' },
      lastUpdatedBy: { documentType: 'call_sheet', label: 'Call Sheet', reportedOn: null, updatedAt: null },
    },
    // Day 12 - PLANNED (not yet shot)
    {
      dayNumber: 12,
      status: 'planned',
      statusColor: '#A0AEC0',
      scenes: ['10pt', '2pt', '61'],
      scenesPlanned: ['10pt', '2pt', '61'],
      scenesShot: [], // Not shot yet
      plannedScenesCount: 3,
      shotScenesCount: 0,
      plannedPages: '5 6/8',
      actualPages: '0/8',
      plannedPagesNumeric: 5.75,
      actualPagesNumeric: 0,
      progressPercent: 0,
      crewCallTime: '13:00',
      actualFirstShotTime: 'N/A',
      characters: [],
      punctualitySummary: { onTimeCount: 0, lateCount: 0, avgVarianceMinutes: null },
      firstLocation: { name: '2415 Firestone Blvd., South Gate, CA 90280', status: 'INT' },
      weather: { forecast: '0% chance of rain', temp: 'High 70 / Low 56' },
      lastUpdatedBy: { documentType: 'call_sheet', label: 'Call Sheet', reportedOn: null, updatedAt: null },
    },
    // Day 13 - PLANNED (not yet shot)
    {
      dayNumber: 13,
      status: 'planned',
      statusColor: '#A0AEC0',
      scenes: ['29', '31', '51pt', '53', '54pt', '58pt', '60pt'],
      scenesPlanned: ['29', '31', '51pt', '53', '54pt', '58pt', '60pt'],
      scenesShot: [], // Not shot yet
      plannedScenesCount: 7,
      shotScenesCount: 0,
      plannedPages: '4 5/8',
      actualPages: '0/8',
      plannedPagesNumeric: 4.625,
      actualPagesNumeric: 0,
      progressPercent: 0,
      crewCallTime: '13:00',
      actualFirstShotTime: 'N/A',
      characters: [],
      punctualitySummary: { onTimeCount: 0, lateCount: 0, avgVarianceMinutes: null },
      firstLocation: { name: "LAURA'S HOUSE - MASTER BEDROOM", status: 'INT' },
      weather: { forecast: 'Partly Cloudy, 0% chance of rain', temp: 'High 71 / Low 55' },
      lastUpdatedBy: { documentType: 'call_sheet', label: 'Call Sheet', reportedOn: null, updatedAt: null },
    },
  ],
};

/**
 * Day 10 Demo Drift Analysis Data
 * Only Days 1-10 (production data through end of Day 10)
 */
export const demoDay10DriftAnalysisData = [
  {
    shoot_day_number: 1,
    shoot_date: '2016-03-29',
    schedule_version: '3-28 Prototype Schedule (final final).pdf',
    schedule_revision_date: '2016-03-28T00:00:00.000Z',
    original_planned_pages: '4 2/8',
    revised_planned_pages: '4 2/8',
    actual_shot_pages: '3 7/8',
    daily_variance: '-3/8',
    daily_variance_numeric: '-0.375',
    cumulative_drift_original: '-3/8',
    cumulative_drift_original_numeric: '-0.375',
    cumulative_drift_revised: '-3/8',
    cumulative_drift_revised_numeric: '-0.375',
    current_plan_name: 'Original (3/28/2016)',
    cumulative_since_latest_revision: '0',
    cumulative_since_latest_revision_numeric: '0',
  },
  {
    shoot_day_number: 2,
    shoot_date: '2016-03-30',
    schedule_version: '3-28 Prototype Schedule (final final).pdf',
    schedule_revision_date: '2016-03-28T00:00:00.000Z',
    original_planned_pages: '4 5/8',
    revised_planned_pages: '4 5/8',
    actual_shot_pages: '4 4/8',
    daily_variance: '-1/8',
    daily_variance_numeric: '-0.13',
    cumulative_drift_original: '-4/8',
    cumulative_drift_original_numeric: '-0.505',
    cumulative_drift_revised: '-4/8',
    cumulative_drift_revised_numeric: '-0.505',
    current_plan_name: 'Original (3/28/2016)',
    cumulative_since_latest_revision: '-1/8',
    cumulative_since_latest_revision_numeric: '-0.13',
  },
  {
    shoot_day_number: 3,
    shoot_date: '2016-03-31',
    schedule_version: '4-11 Prototype Schedule Full.pdf',
    schedule_revision_date: '2016-04-11T00:00:00.000Z',
    original_planned_pages: '4 4/8',
    revised_planned_pages: '4 4/8',
    actual_shot_pages: '3 1/8',
    daily_variance: '-1 3/8',
    daily_variance_numeric: '-1.375',
    cumulative_drift_original: '-1 7/8',
    cumulative_drift_original_numeric: '-1.88',
    cumulative_drift_revised: '-1 7/8',
    cumulative_drift_revised_numeric: '-1.88',
    current_plan_name: 'Blue (4/11/2016)',
    cumulative_since_latest_revision: '0',
    cumulative_since_latest_revision_numeric: '0',
  },
  {
    shoot_day_number: 4,
    shoot_date: '2016-04-01',
    schedule_version: '4-11 Prototype Schedule Full.pdf',
    schedule_revision_date: '2016-04-11T00:00:00.000Z',
    original_planned_pages: '5',
    revised_planned_pages: '5',
    actual_shot_pages: '3 1/8',
    daily_variance: '-1 7/8',
    daily_variance_numeric: '-1.875',
    cumulative_drift_original: '-3 6/8',
    cumulative_drift_original_numeric: '-3.755',
    cumulative_drift_revised: '-3 6/8',
    cumulative_drift_revised_numeric: '-3.755',
    current_plan_name: 'Blue (4/11/2016)',
    cumulative_since_latest_revision: '-1 7/8',
    cumulative_since_latest_revision_numeric: '-1.875',
  },
  {
    shoot_day_number: 5,
    shoot_date: '2016-04-13',
    schedule_version: '4-11 Prototype Schedule Full.pdf',
    schedule_revision_date: '2016-04-11T00:00:00.000Z',
    original_planned_pages: '3 7/8',
    revised_planned_pages: '3 7/8',
    actual_shot_pages: '3 4/8',
    daily_variance: '-3/8',
    daily_variance_numeric: '-0.38',
    cumulative_drift_original: '-4 1/8',
    cumulative_drift_original_numeric: '-4.135',
    cumulative_drift_revised: '-4 1/8',
    cumulative_drift_revised_numeric: '-4.135',
    current_plan_name: 'Blue (4/11/2016)',
    cumulative_since_latest_revision: '-2 2/8',
    cumulative_since_latest_revision_numeric: '-2.255',
  },
  {
    shoot_day_number: 6,
    shoot_date: '2016-04-05',
    schedule_version: '4-11 Prototype Schedule Full.pdf',
    schedule_revision_date: '2016-04-11T00:00:00.000Z',
    original_planned_pages: '4',
    revised_planned_pages: '3 6/8',
    actual_shot_pages: '2 2/8',
    daily_variance: '-1 4/8',
    daily_variance_numeric: '-1.5',
    cumulative_drift_original: '-5 7/8',
    cumulative_drift_original_numeric: '-5.885',
    cumulative_drift_revised: '-5 5/8',
    cumulative_drift_revised_numeric: '-5.635',
    current_plan_name: 'Blue (4/11/2016)',
    cumulative_since_latest_revision: '-3 6/8',
    cumulative_since_latest_revision_numeric: '-3.755',
  },
  {
    shoot_day_number: 7,
    shoot_date: '2016-04-06',
    schedule_version: '4-11 Prototype Schedule Full.pdf',
    schedule_revision_date: '2016-04-11T00:00:00.000Z',
    original_planned_pages: '6 3/8',
    revised_planned_pages: '6 5/8',
    actual_shot_pages: '6 3/8',
    daily_variance: '-2/8',
    daily_variance_numeric: '-0.255',
    cumulative_drift_original: '-5 7/8',
    cumulative_drift_original_numeric: '-5.89',
    cumulative_drift_revised: '-5 7/8',
    cumulative_drift_revised_numeric: '-5.89',
    current_plan_name: 'Blue (4/11/2016)',
    cumulative_since_latest_revision: '-4',
    cumulative_since_latest_revision_numeric: '-4.01',
  },
  {
    shoot_day_number: 8,
    shoot_date: '2016-04-07',
    schedule_version: '4-11 Prototype Schedule Full.pdf',
    schedule_revision_date: '2016-04-11T00:00:00.000Z',
    original_planned_pages: '4 5/8',
    revised_planned_pages: '5 3/8',
    actual_shot_pages: '3 5/8',
    daily_variance: '-1 6/8',
    daily_variance_numeric: '-1.755',
    cumulative_drift_original: '-6 7/8',
    cumulative_drift_original_numeric: '-6.895',
    cumulative_drift_revised: '-7 5/8',
    cumulative_drift_revised_numeric: '-7.645',
    current_plan_name: 'Blue (4/11/2016)',
    cumulative_since_latest_revision: '-5 6/8',
    cumulative_since_latest_revision_numeric: '-5.765',
  },
  {
    shoot_day_number: 9,
    shoot_date: '2016-04-08',
    schedule_version: '4-11 Prototype Schedule Full.pdf',
    schedule_revision_date: '2016-04-11T00:00:00.000Z',
    original_planned_pages: '7 5/8',
    revised_planned_pages: '5 4/8',
    actual_shot_pages: '4 7/8',
    daily_variance: '-5/8',
    daily_variance_numeric: '-0.625',
    cumulative_drift_original: '-9 5/8',
    cumulative_drift_original_numeric: '-9.65',
    cumulative_drift_revised: '-8 2/8',
    cumulative_drift_revised_numeric: '-8.27',
    current_plan_name: 'Blue (4/11/2016)',
    cumulative_since_latest_revision: '-6 3/8',
    cumulative_since_latest_revision_numeric: '-6.39',
  },
  {
    shoot_day_number: 10,
    shoot_date: '2016-04-11',
    schedule_version: '4-11 Prototype Schedule Full.pdf',
    schedule_revision_date: '2016-04-11T00:00:00.000Z',
    original_planned_pages: '8 3/8',
    revised_planned_pages: '7 7/8',
    actual_shot_pages: '7 6/8',
    daily_variance: '-1/8',
    daily_variance_numeric: '-0.13',
    cumulative_drift_original: '-10 2/8',
    cumulative_drift_original_numeric: '-10.28',
    cumulative_drift_revised: '-8 3/8',
    cumulative_drift_revised_numeric: '-8.4',
    current_plan_name: 'Blue (4/11/2016)',
    cumulative_since_latest_revision: '-6 4/8',
    cumulative_since_latest_revision_numeric: '-6.52',
  },
];
